import React from "react";
import { Modal, Button, Row } from "react-bootstrap";

const ImportModal = ({ closeModal, importData, show }) => {
  const handleClose = () => {
    closeModal();
  };

  return (
    <Modal show={show} onHide={() => handleClose()}>
      <Modal.Header closeButton>
        <Modal.Title>Import Residents</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <label>
          Please make sure all data is correct, once you hit 'Import' the data
          will be attached to new or existing Residents. It will be your
          responsibility to fix any data that doesn't match quite well
        </label>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => handleClose()}>
          Cancel Import
        </Button>
        <Button variant="primary" onClick={() => importData()}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImportModal;
